import { createRoute, redirect } from '@tanstack/react-router'

import { DashboardSkeleton } from '@shared/layouts'
import { DynamicRouteParameterWPrefix, StaticRouteParameter } from 'config/routing'
import { General, JSON, Watch } from 'domains/Workspaces/Video/Streams/Stream'
import { Overview as StreamObjectsOverview } from 'domains/Workspaces/Video/Streams/Stream/Objects'
import { videoStreamsRoute } from 'pages/NWPlatform/Workspaces/Workspace/Video/Streams'
import { Structure } from 'pages/NWPlatform/Workspaces/Workspace/Video/Streams/Stream/Structure'

export const videoStreamRoute = createRoute({
  getParentRoute: () => videoStreamsRoute,
  path: DynamicRouteParameterWPrefix.VIDEOSTREAM_ID,
  beforeLoad: ({ location, params: { videostreamId } }) => {
    const encodedParam = encodeURIComponent(videostreamId)
    if (location.pathname.endsWith(encodedParam) || location.pathname.endsWith(`${encodedParam}/`)) {
      throw redirect({ replace: true, from: videoStreamRoute.fullPath, to: videoStreamGeneralRoute.to })
    }
  },
  loader: () => ({
    crumb: {
      title: null,
    },
  }),
})

export const videoStreamLayoutRoute = createRoute({
  getParentRoute: () => videoStreamRoute,
  id: 'videoStreamLayout',
  component: Structure,
})

/** Gives the General tab the xl max-width and full-height container its edit mode needs. */
export const videoStreamDashboardLayoutRoute = createRoute({
  getParentRoute: () => videoStreamLayoutRoute,
  id: 'videoStreamDashboardLayout',
  component: DashboardSkeleton,
})

export const videoStreamGeneralRoute = createRoute({
  getParentRoute: () => videoStreamDashboardLayoutRoute,
  path: StaticRouteParameter.GENERAL,
  component: General,
})

export const videoStreamWatchRoute = createRoute({
  getParentRoute: () => videoStreamLayoutRoute,
  path: StaticRouteParameter.WATCH,
  component: Watch,
})

export const videoStreamConfigRoute = createRoute({
  getParentRoute: () => videoStreamLayoutRoute,
  path: StaticRouteParameter.CONFIG,
  component: JSON,
})

type VideoStreamObjectsOverviewSearch = {
  query?: string
}

export const videoStreamObjectsOverviewRoute = createRoute({
  getParentRoute: () => videoStreamLayoutRoute,
  path: StaticRouteParameter.OBJECTS,
  component: StreamObjectsOverview,
  validateSearch: (search: VideoStreamObjectsOverviewSearch) => ({
    ...(search.query && { query: search.query }),
  }),
})
